import {Box, FormControl} from '@mui/material';
import {useField} from 'formik';
import {YSThemeStyleRadius} from 'main/utility/AppContextProvider/YSTheme';
import {getColor, getFormattedValue} from 'main/utility/helper/FormatUtil';
import PropTypes from 'prop-types';

const AppTagField = (props) => {
  const [field] = useField(props.name);
  const textColor = getColor(field.value, props.txtcolor);
  const bgColor = getColor(field.value, props.bgcolor);
  const content = getFormattedValue(field, field.value, bgColor, textColor);

  return (
    content && (
      <FormControl fullWidth>
        <Box
          sx={{
            height: 35,
            marginTop: 1.25,
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            justifyContent: 'center',
            px: 3,
            borderRadius: `${YSThemeStyleRadius.SHARP}px`,
            backgroundColor: bgColor,
            color: textColor,

            fontSize: 12,
            fontWeight: 700,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            border: '1px solid rgba(0,0,0,0.05)',
          }}
        >
          {content}
        </Box>
      </FormControl>
    )
  );
};

AppTagField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelId: PropTypes.string,

  halignvalue: PropTypes.string,
  txtcolor: PropTypes.string,
  bgcolor: PropTypes.string,
};

export default AppTagField;
